import { z } from 'zod';

import {
  TravelSettings,
  TravelSettingsRequest,
  leadTimeEnforcementList,
  leadTimeUnitList,
  travelEnforcementList,
  travelReturnModeList,
} from './TravelSettingsTypes';

export const travelSettingsSchema = z.object({
  daysBeforeDeparture: z.number().int().min(0),
  leadTimeUnit: z.enum(leadTimeUnitList),
  erasmusDaysBeforeDeparture: z.number().int().min(0),
  erasmusLeadTimeUnit: z.enum(leadTimeUnitList),
  leadTimeEnforcement: z.enum(leadTimeEnforcementList),
  parallelEnforcement: z.enum(travelEnforcementList),
  erasmusParallelEnforcement: z.enum(travelEnforcementList),
  leaveDaysEnforcement: z.enum(travelEnforcementList),
  dayCapEnforcement: z.enum(travelEnforcementList),
  returnMode: z.enum(travelReturnModeList),
  reminderIntervalDays: z.number().int().min(1).max(365),
  researchSecretariatVerification: z.boolean(),
  internationalSecretariatVerification: z.boolean(),
});

export type TravelSettingsSchema = z.infer<typeof travelSettingsSchema>;

export function toTravelSettingsSchema(settings: TravelSettings): TravelSettingsSchema {
  return {
    daysBeforeDeparture: settings.daysBeforeDeparture,
    leadTimeUnit: settings.leadTimeUnit,
    erasmusDaysBeforeDeparture: settings.erasmusDaysBeforeDeparture,
    erasmusLeadTimeUnit: settings.erasmusLeadTimeUnit,
    leadTimeEnforcement: settings.leadTimeEnforcement,
    parallelEnforcement: settings.parallelEnforcement,
    erasmusParallelEnforcement: settings.erasmusParallelEnforcement,
    leaveDaysEnforcement: settings.leaveDaysEnforcement,
    dayCapEnforcement: settings.dayCapEnforcement,
    returnMode: settings.returnMode,
    reminderIntervalDays: settings.reminderIntervalDays,
    researchSecretariatVerification: settings.researchSecretariatVerification,
    internationalSecretariatVerification: settings.internationalSecretariatVerification,
  };
}

export function toTravelSettingsRequest(values: TravelSettingsSchema, version: number): TravelSettingsRequest {
  return {
    daysBeforeDeparture: values.daysBeforeDeparture,
    leadTimeUnit: values.leadTimeUnit,
    erasmusDaysBeforeDeparture: values.erasmusDaysBeforeDeparture,
    erasmusLeadTimeUnit: values.erasmusLeadTimeUnit,
    leadTimeEnforcement: values.leadTimeEnforcement,
    parallelEnforcement: values.parallelEnforcement,
    erasmusParallelEnforcement: values.erasmusParallelEnforcement,
    leaveDaysEnforcement: values.leaveDaysEnforcement,
    dayCapEnforcement: values.dayCapEnforcement,
    returnMode: values.returnMode,
    reminderIntervalDays: values.reminderIntervalDays,
    researchSecretariatVerification: values.researchSecretariatVerification,
    internationalSecretariatVerification: values.internationalSecretariatVerification,
    version,
  };
}
